import HomePage from "../pages/HomePage";
import DashboardPage from "../pages/DashboardPage";
import LeaguePage from "../pages/LeaguePage";
import LeagueEditPage from "../pages/LeagueEditPage";
import LeagueRulesPage from "../pages/LeagueRulesPage";
import MatchPage from "../pages/MatchPage";
import TeamPage from "../pages/TeamPage";
import ProfilePage from "../pages/ProfilePage";

const APP_ROUTE_COMPONENTS = {
  home: HomePage,
  dashboard: DashboardPage,
  league: LeaguePage,
  "league-edit": LeagueEditPage,
  "league-rules": LeagueRulesPage,
  match: MatchPage,
  team: TeamPage,
  profile: ProfilePage,
};

export function resolveAppRouteKey({ currentPage, currentSubpage, signedIn }) {
  if (currentPage === "home") {
    return signedIn ? "dashboard" : "home";
  }

  if (currentPage === "account") {
    return "profile";
  }

  if (currentPage === "teams") {
    return "team";
  }

  if (currentPage === "play") {
    return "match";
  }

  if (currentPage === "leagues") {
    if (currentSubpage === "edit") return "league-edit";
    if (currentSubpage === "rules") return "league-rules";
    return "league";
  }

  return currentPage;
}

export function getAppRouteComponent(routeKey) {
  return APP_ROUTE_COMPONENTS[routeKey] || null;
}
